import { ListTree } from 'lucide-react'
import { useId, useState, type ReactNode } from 'react'

import './browse.css'

/**
 * Рабочая область «выбор слева — результат справа»: дерево (или любой выбор) в боковой колонке, результат рядом.
 * На узком экране колонка прячется под кнопку «Где смотрим: …», в которой сказано, что выбрано сейчас, — выбор не
 * съедает экран телефона, но и не пропадает.
 */
export function Workbench({
  side,
  sideTitle,
  sideSummary,
  children,
}: {
  side: ReactNode
  /** Заголовок колонки выбора: «Где смотрим». */
  sideTitle: string
  /** Что выбрано сейчас, словами: показывается на кнопке узкого экрана. */
  sideSummary: string
  children: ReactNode
}) {
  const [open, setOpen] = useState(false)
  const panelId = useId()
  return (
    <div className="krp-workbench">
      <aside className="krp-workbench__side" data-open={open || undefined} aria-label={sideTitle}>
        <button
          type="button"
          className="krp-workbench__toggle"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((current) => !current)}
        >
          <ListTree size={16} aria-hidden="true" />
          <span>
            <b>{sideTitle}:</b> {sideSummary}
          </span>
        </button>
        <div id={panelId} className="krp-workbench__panel">
          {side}
        </div>
      </aside>
      <div className="krp-workbench__main">{children}</div>
    </div>
  )
}
